import { push } from 'connected-react-router';
import _ from 'lodash';

import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';
import LocalStorageHelper from '../helpers/local_storage';

export function getPublishedEvent() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_PUBLISHED_EVENT_REQUEST,
			payload: { loading: true }
		});

		const response = await API.event.getPublishedEvent();

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_PUBLISHED_EVENT_ERROR,
				payload: {
					// meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { event } = response.data;

		dispatch({
			type: ActionTypes.GET_PUBLISHED_EVENT_SUCCESS,
			payload: {
				event,
				loading: false
			}
		});
	};
}

export function requestAuthOtp({ email, query, resend=false }) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.LOGIN_REQUEST_OTP_REQUEST,
			payload: {
				loadingRequestSubmit: true
			}
		});

		const response = await API.auth.requestAuthOtp({ email });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.LOGIN_REQUEST_OTP_ERROR,
				payload: {
					loadingRequestSubmit: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.LOGIN_REQUEST_OTP_SUCCESS,
			payload: {
				loadingRequestSubmit: false,
				...resend && { meta: response.meta }
			}
		});

		// Stop execution if it will only resend otp
		if (resend) {
			return;
		}

		// store email
		LocalStorageHelper.setEmail(email);

		// Navigate to specified page
		if (query.path && query.path !== '/' && query.path !== '') {
			dispatch(push(`/login/verify?path=${query.path}`));
			return;
		}

		// Navigate to next page
		dispatch(push('/login/verify'));
	};
}

export function verifyAuthOtp({ email, otp, query }) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.LOGIN_VERIFY_OTP_REQUEST,
			payload: {
				loadingVerifySubmit: true
			}
		});

		const response = await API.auth.verifyAuthOtp({ email, otp });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.LOGIN_VERIFY_OTP_ERROR,
				payload: {
					loadingVerifySubmit: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.LOGIN_VERIFY_OTP_SUCCESS,
			payload: {
				loadingVerifySubmit: false
			}
		});

		const { auth, user } = response.data;

		// Remove previously stored email
		LocalStorageHelper.removeEmail();

		// Store response
		LocalStorageHelper.setUser(user);
		LocalStorageHelper.setToken(auth.token);

		if (_.get(user, 'application')) {
			// Navigate to last step
			dispatch(push(`/application?step=${user.application.current_step}&application_id=${user.application._id}`));
			return;
		}

		// Navigate to specified page
		if (query.path && query.path !== '/' && query.path !== '') {
			dispatch(push(query.path));
			return;
		}

		// Navigate to next page
		dispatch(push('/application'));
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_LOGIN_META });
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_LOGIN_PAGE });
	};
}